import { ApiInstance, RetrySettings } from '@src/services/api-instance';
import { HubExtensionsGetByIdResponseDTO } from './dto/hub-extensions.getById.response.dto';
import { getAuthToken } from '@src/services/auth-service';
import { HubExtensionsPostSubscriptionByIdBodyDTO } from './dto/hub-extensions.postSubscriptionById.body.dto';

export class HubExtensionsService {
  private readonly client: ApiInstance;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/extensions`, client.getTimeout());
  }

  async getByIdOrName(request: {
    idOrName: string;
    params?: {
      byName: boolean;
    };
    settings?: RetrySettings;
  }): Promise<HubExtensionsGetByIdResponseDTO> {
    return (
      await this.client.get<HubExtensionsGetByIdResponseDTO>(`${request.idOrName}`, request.params, {
        bearerToken: await getAuthToken(),
        settings: request.settings,
      })
    ).data;
  }

  async postSubscriptionById(request: {
    id: string;
    body: HubExtensionsPostSubscriptionByIdBodyDTO;
    settings?: RetrySettings;
  }): Promise<void> {
    await this.client.post<HubExtensionsPostSubscriptionByIdBodyDTO, void>(
      `${request.id}/subscriptions`,
      request.body,
      {
        bearerToken: await getAuthToken(),
        settings: request.settings,
      },
    );
  }

  async deleteSubscriptionById(request: {
    id: string;
    organizationId: string;
    settings?: RetrySettings;
  }): Promise<void> {
    await this.client.delete<void>(
      `${request.id}/subscriptions/${request.organizationId}`,
      {},
      {
        bearerToken: await getAuthToken(),
        settings: request.settings,
      },
    );
  }
}
